import PedidoDetalhe from './PedidoDetalhe';

export default PedidoDetalhe;